import { Component } from 'react';

export default class ErrorBoundary extends Component {
  state = { comErro: false };

  static getDerivedStateFromError() {
    return { comErro: true };
  }

  componentDidCatch(error, info) {
    console.error('Erro não tratado na interface:', error, info);
  }

  render() {
    if (!this.state.comErro) return this.props.children;

    return (
      <div
        className="d-flex flex-column align-items-center justify-content-center text-center"
        style={{ minHeight: '100vh', padding: 24, background: 'var(--am-papel)' }}
      >
        <span className="ms" style={{ fontSize: 44, color: 'var(--am-critico)', marginBottom: 12 }}>
          error
        </span>
        <div style={{ fontSize: 18, fontWeight: 700, color: 'var(--am-tinta)', marginBottom: 6 }}>
          Ocorreu um erro inesperado
        </div>
        <div style={{ fontSize: 14, color: 'var(--am-cinza-texto-2)', marginBottom: 20, maxWidth: 420 }}>
          A tela travou por um problema imprevisto. Recarregar a página costuma resolver.
        </div>
        <button type="button" className="am-btn am-btn-dark" onClick={() => window.location.reload()}>
          <span className="ms">refresh</span>
          Recarregar página
        </button>
      </div>
    );
  }
}
